import { REMOVER_FILTRO_AGENDAMENTO_VIAGEM } from '../types'

export default function removerFiltroAgendamentoViagem (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_AGENDAMENTO_VIAGEM
  }
}
